import { Center, LoadingOverlay, Space } from '@mantine/core';
import { IconBox } from '@tabler/icons';
import { FC, useContext } from 'react';
import ResourcesTable from '../../Organismns/Resources/table/general/ResourcesTable';
import { ResourcesContext } from '../../Service/Context/ResourcesContext';
import PaginationNav from '../../Molecules/Navigation/PaginationNav';
import AddResourceIcon from '../../Organismns/Resources/AddResourceIcon';
import EmptyListState from '../../Molecules/EmptyListState';

const AllResources: FC = () => {
  const { loading, resources, navigation, filter, empty, updateFilter } = useContext(ResourcesContext);
  const { totalCount, totalPages } = navigation;
  const { pageNumber, pageSize } = filter;

  return (
    <div style={{ position: 'relative' }}>
      <LoadingOverlay visible={loading} overlayBlur={2} loaderProps={{ size: 'xl' }} />
      {resources.length === 0 && <ResourcesNotFound empty={empty} />}
      {resources.length > 0 && <ResourcesTable resources={resources} />}
      <PaginationNav
        pageSize={pageSize}
        pageNumber={pageNumber}
        totalCount={totalCount}
        totalPages={totalPages}
        entityName="Ressourcen"
        onChange={(newPageNumber) => updateFilter({ pageNumber: newPageNumber - 1 })}
      />
    </div>
  );
};

export default AllResources;

const ResourcesNotFound: FC<{ empty: boolean }> = ({ empty }) => (
  <EmptyListState
    icon={<IconBox size={30} stroke={1.6} />}
    title={empty ? 'Noch keine Ressourcen' : 'Keine Ressourcen gefunden'}
    maxWidth={empty ? 640 : undefined}
  >
    {empty ? (
      <Center inline>
        Du hast noch keine Ressource erstellt. Klicke auf
        <Space w={5} />
        <AddResourceIcon />
        <Space w={2} />, um zu beginnen.
      </Center>
    ) : (
      <>
        Die Kombination der ausgewählten <b>Filter</b> erzielt keine Ergebnisse.
      </>
    )}
  </EmptyListState>
);
